export default {
  isViewRollBook: (state, getters, rootState, rootGetters) => {
    return state.isViewRollBook;
  }
};
